import React, { useEffect, useState } from 'react';
import PostCard from './PostCard';
import axios from 'axios';
import { Alert, AlertTitle, Pagination, Stack } from '@mui/material';
import { isCompany } from '../../Config/isCompany';
import NotFoundPage from '../../Pages/NotFoundPage';

const MyPosts = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6; // Maksimum 6 ilan gösterilecek

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get('https://kariyer.biyomed.net/api/posts/getCompanyPosts', { withCredentials: true });
        setPosts(response.data.posts);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  // Sayfa numaralandırması için hesaplamalar
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (  <>{isCompany ?     <div className="jp_listing_sidebar_main_wrapper">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="jp_listing_heading_wrapper">
            <h2>
              <span>{posts.length}</span>  İlan bulundu
            </h2>
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 hidden-sm hidden-xs">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="jp_add_resume_wrapper jp_job_location_wrapper">
                <div className="jp_add_resume_img_overlay" />
                <div className="jp_add_resume_cont">
                  <img style={{ width: "120px", height: "30px" }} src="https://biyomed.net/kariyer_images/biyomedlogosiyahzemin2.png" alt="logo" />
                  <h4>Biyomedikal Mühendisi Arıyorum</h4>
                  <ul>
                    <li>
                      <a href="/create-post">
                        <i className="fa fa-plus-circle" /> &nbsp;İş/Staj İlanı Ekle
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="tab-content">
                {posts.length > 0 ?                 <div id="grid" className="tab-pane fade in active">
                  <div className="row">
                    {currentPosts.map((post) => (
                      <PostCard key={post.id} post={post} />
                    ))}
                  </div>
                  {/* Pagination */}
                  <Stack spacing={2} sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}>
                    <Pagination 
                      count={Math.ceil(posts.length / postsPerPage)} 
                      page={currentPage} 
                      onChange={handlePageChange} 
                      color="primary" 
                    />
                  </Stack>
                </div> : <><Alert sx={{mt:5}} severity="info">
            <AlertTitle>Hatırlatma</AlertTitle>
            Kaydınızı tamamlamadan ilan oluşturamazsınız. Lütfen Hesabım sekmesinden kaydınızı tamamlayınız.
          </Alert><p style={{fontSize:'40px', marginTop:50}}>Burada hiç ilan yok...</p></>}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> : <NotFoundPage/>}</>

  );
};

export default MyPosts;
